// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GatePass_backdrop__-ezTQ {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.GatePass_modal__g1gel {
  position: relative;
  width: 90vw;
  max-width: 506px;
  background: linear-gradient(180deg, #644ee5 0%, #a600ff 100%);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  color: #fff;
  padding: 32px 32px 32px;
  text-align: center;
  /* overflow: hidden; */
}

.GatePass_modalGradient2__Tnaox {
  background: linear-gradient(180deg, #6d3e07 0%, #ffa200 100%);
}

.GatePass_modalGradient3__s\\+GiE {
  background: linear-gradient(180deg, #6d0726 0%, #ef69db 100%);
}

.GatePass_gifContainer__ocMLG {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-top: 16px; */

  margin-left: auto;
  margin-right: auto;
}
.GatePass_statusPillExpired__qBwJT {
  background: #fee2e2;
  color: #e73826;
  border-radius: 8px;
  padding: 8px 12px;
  margin: 24px auto;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  border: 2px solid #e73826;
}

.GatePass_gif__eT\\+uA {
  width: 150px; /* adjust as needed */
  height: 150px; /* or auto for natural size */
  object-fit: contain;
}

.GatePass_profileCircle__PnFRy {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #00c853;
  border: 3px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}

.GatePass_title__Q9ZvS {
  margin-top: 10px;
  font-size: 28px;
  font-weight: 700;
  font-family: 'Inter';
  font-weight: 700;
  font-style: Bold;
  font-size: 48px;
  line-height: 100%;
  letter-spacing: 0%;
}

.GatePass_row__y9h-S {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 14px;
}

.GatePass_label__9hOaD {
  opacity: 0.85;
  text-align: left;
}

.GatePass_value__cw0nH {
  font-weight: 600;
  text-align: right;

  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: right;
}

.GatePass_statusPill__2qJkj {
  background: #c8e6c9;
  color: #dcfce7;
  border-radius: 8px;
  padding: 8px 12px;
  margin: 24px auto;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  border: 2px solid #86efac;
  color: #15803d;
}
.GatePass_gifContainer__ocMLG {
  width: 120px;
  height: 120px;
  /* margin-bottom: 12px; */
}
.GatePass_namecontainer__h4sLo {
  padding-bottom: 24px;
  width: 100%;
  border-bottom: 1px solid #fff;
}
.GatePass_lastRow__6WTa2 {
  margin-bottom: 0 !important;
}

.GatePass_infoBox__7uhBO {
  background: #fff;
  color: #000;
  border-radius: 10px;
  padding: 16px 20px;
  margin-top: 10px;
  text-align: left;
}

.GatePass_infoRow__02zE7 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.GatePass_infoLabel__Bsrom {
  opacity: 0.7;
}

.GatePass_infoValue__U3ccJ {
  font-weight: 600;
}

.GatePass_footerButton__qfxX8 {
  margin-top: 20px;
  background: #fef9c3;
  border: 2px solid #facc15;
  color: #000;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  transition: all 0.2s ease;
  color: #854d0e;

  font-family: 'Inter';
  font-weight: 500;
  font-style: Italic;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
}

.GatePass_closeBtn__ZFIMk {
  position: absolute;
  top: 27px;
  right: 29px;
  background: transparent;
  border: none;
  /* font-size: 22px; */
  color: #ffffffcc;
  cursor: pointer;
  transition: color 0.2s ease;
}

.GatePass_closeBtn__ZFIMk:hover {
  color: #ffffff;
}

@media (max-width: 540px) {
  .GatePass_modal__g1gel {
    width: 92vw;
    padding: 40px 20px 24px;
  }
  .GatePass_infoBox__7uhBO {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/StudentGatePass/components/GatePass.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;;EAEtB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY,EAAE,qBAAqB;EACnC,aAAa,EAAE,6BAA6B;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;;EAEd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n.modal {\n  position: relative;\n  width: 90vw;\n  max-width: 506px;\n  background: linear-gradient(180deg, #644ee5 0%, #a600ff 100%);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  color: #fff;\n  padding: 32px 32px 32px;\n  text-align: center;\n  /* overflow: hidden; */\n}\n\n.modalGradient2 {\n  background: linear-gradient(180deg, #6d3e07 0%, #ffa200 100%);\n}\n\n.modalGradient3 {\n  background: linear-gradient(180deg, #6d0726 0%, #ef69db 100%);\n}\n\n.gifContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* margin-top: 16px; */\n\n  margin-left: auto;\n  margin-right: auto;\n}\n.statusPillExpired {\n  background: #fee2e2;\n  color: #e73826;\n  border-radius: 8px;\n  padding: 8px 12px;\n  margin: 24px auto;\n  width: 100%;\n  font-weight: 600;\n  font-size: 14px;\n  border: 2px solid #e73826;\n}\n\n.gif {\n  width: 150px; /* adjust as needed */\n  height: 150px; /* or auto for natural size */\n  object-fit: contain;\n}\n\n.profileCircle {\n  position: absolute;\n  top: -25px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #00c853;\n  border: 3px solid #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 18px;\n  color: #fff;\n}\n\n.title {\n  margin-top: 10px;\n  font-size: 28px;\n  font-weight: 700;\n  font-family: 'Inter';\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 48px;\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px;\n  font-size: 14px;\n}\n\n.label {\n  opacity: 0.85;\n  text-align: left;\n}\n\n.value {\n  font-weight: 600;\n  text-align: right;\n\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: right;\n}\n\n.statusPill {\n  background: #c8e6c9;\n  color: #dcfce7;\n  border-radius: 8px;\n  padding: 8px 12px;\n  margin: 24px auto;\n  width: 100%;\n  font-weight: 600;\n  font-size: 14px;\n  border: 2px solid #86efac;\n  color: #15803d;\n}\n.gifContainer {\n  width: 120px;\n  height: 120px;\n  /* margin-bottom: 12px; */\n}\n.namecontainer {\n  padding-bottom: 24px;\n  width: 100%;\n  border-bottom: 1px solid #fff;\n}\n.lastRow {\n  margin-bottom: 0 !important;\n}\n\n.infoBox {\n  background: #fff;\n  color: #000;\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-top: 10px;\n  text-align: left;\n}\n\n.infoRow {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.infoLabel {\n  opacity: 0.7;\n}\n\n.infoValue {\n  font-weight: 600;\n}\n\n.footerButton {\n  margin-top: 20px;\n  background: #fef9c3;\n  border: 2px solid #facc15;\n  color: #000;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 10px 16px;\n  cursor: pointer;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  transition: all 0.2s ease;\n  color: #854d0e;\n\n  font-family: 'Inter';\n  font-weight: 500;\n  font-style: Italic;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0%;\n}\n\n.closeBtn {\n  position: absolute;\n  top: 27px;\n  right: 29px;\n  background: transparent;\n  border: none;\n  /* font-size: 22px; */\n  color: #ffffffcc;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.closeBtn:hover {\n  color: #ffffff;\n}\n\n@media (max-width: 540px) {\n  .modal {\n    width: 92vw;\n    padding: 40px 20px 24px;\n  }\n  .infoBox {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `GatePass_backdrop__-ezTQ`,
	"modal": `GatePass_modal__g1gel`,
	"modalGradient2": `GatePass_modalGradient2__Tnaox`,
	"modalGradient3": `GatePass_modalGradient3__s+GiE`,
	"gifContainer": `GatePass_gifContainer__ocMLG`,
	"statusPillExpired": `GatePass_statusPillExpired__qBwJT`,
	"gif": `GatePass_gif__eT+uA`,
	"profileCircle": `GatePass_profileCircle__PnFRy`,
	"title": `GatePass_title__Q9ZvS`,
	"row": `GatePass_row__y9h-S`,
	"label": `GatePass_label__9hOaD`,
	"value": `GatePass_value__cw0nH`,
	"statusPill": `GatePass_statusPill__2qJkj`,
	"namecontainer": `GatePass_namecontainer__h4sLo`,
	"lastRow": `GatePass_lastRow__6WTa2`,
	"infoBox": `GatePass_infoBox__7uhBO`,
	"infoRow": `GatePass_infoRow__02zE7`,
	"infoLabel": `GatePass_infoLabel__Bsrom`,
	"infoValue": `GatePass_infoValue__U3ccJ`,
	"footerButton": `GatePass_footerButton__qfxX8`,
	"closeBtn": `GatePass_closeBtn__ZFIMk`
};
export default ___CSS_LOADER_EXPORT___;
